import axios from 'axios'
import { SET_EXAM_RULES } from './types'

const state = {
  examRules: {
    attestation_type: [],
    is_disable_check_docs: false,
    level_de: [],
    user_id: ''
  }
}

const mutations = {
  [SET_EXAM_RULES] (state, payload) {
    state.examRules = { ...payload }
  }
}

const getters = {
  examRules (state) {
    return state.examRules
  }
}

const actions = {
  async getExamRules ({ commit, state }) {
    try {
      const url = '/api/de/user-exam-ext-rules'
      const { data } = await axios.get(url)

      if (data.data && data.data.length > 0) {
        commit(SET_EXAM_RULES, { ...data.data[0] })
      }
    } catch (e) {
      throw e
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
